<template>
    <div class="app-right">
        <button class="app-right-hide" @click="closeRightPanel">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" class="feather feather-x" viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12" />
            </svg>
        </button>
        <div class="app-right-content">
            <ul class="menu-list">
                <li class="menu-list-item fadeIn" id="homePage-menu">
                    <router-link to="/">
                        <div class="menu-list-itemContent">
                            <div class="menu-info">
                                <div class="menu-icon-container">
                                    <i class="bi bi-house"></i>
                                </div>
                                <h2 class="menu-info-header">Inicio</h2>
                            </div>
                        </div>
                    </router-link>
                </li>
                <li class="menu-list-item fadeIn" id="adminPanel-menu" :class="{ active: route.path === '/admin-panel' }">
                    <router-link to="/admin-panel">
                        <div class="menu-list-itemContent">
                            <div class="menu-info">
                                <div class="menu-icon-container">
                                    <i class="bi bi-bar-chart-line-fill"></i>
                                </div>
                                <h2 class="menu-info-header">Dashboard</h2>
                            </div>
                        </div>
                    </router-link>
                </li>
                <li class="menu-list-item fadeIn" id="usersPanel-menu" :class="{ active: route.path === '/admin-panel/users-panel' }">
                    <router-link to="/admin-panel/users-panel">
                        <div class="menu-list-itemContent">
                            <div class="menu-info">
                                <div class="menu-icon-container">
                                    <i class="bi bi-person-fill-gear"></i>
                                </div>
                                <h2 class="menu-info-header">Usuarios</h2>
                            </div>
                        </div>
                    </router-link>
                </li>
                <li class="menu-list-item fadeIn" id="appsPanel-menu" :class="{ active: route.path === '/admin-panel/apps-panel' }">
                    <router-link to="/admin-panel/apps-panel">
                        <div class="menu-list-itemContent">
                            <div class="menu-info">
                                <div class="menu-icon-container">
                                    <i class="bi bi-window-plus"></i>
                                </div>
                                <h2 class="menu-info-header">Aplicaciones</h2>
                            </div>
                        </div>
                    </router-link>
                </li>
                
            </ul>
        </div>
        <button class="checkout-button" @click="authStore.logout(router)">Cerrar Sesión</button>
    </div>
</template>

<script setup>

import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';

const route = useRoute();
const authStore = useAuthStore();
const router = useRouter();

const closeRightPanel = () => {
    document.querySelector(".app-right").classList.remove("isOpen");
    document.querySelector(".app-left").classList.remove("hide");
};
</script>